// extracted by mini-css-extract-plugin
module.exports = {"input":"PhotoUploadPage_input__Pbrpw","modalButton":"PhotoUploadPage_modalButton__1JXA5"};